module.exports = __webpack_public_path__ + "img/BATTERY-1000.6f361185.jpg";